export type AiActionFlavor = 'dark' | 'light' | 'accept' | 'discard'
export type AiAction = {
  label: string
  flavor: AiActionFlavor
  order?: number
  disabled: boolean
  tooltip?: string
  icon: string
  onAction: (index?: number) => void
}
export enum AiActionType {
  FIX_WARNINGS = 'fix-warnings',
  GENERATE = 'generate',
  EXPLAIN = 'explain',
  KEEP = 'keep',
  DISCARD = 'discard',
  APPLY = 'apply',
  UNDO = 'undo',
}
